import React from "react";
import ReactDOM from "react-dom";
import sampleData from './data-female-science-marimekko'
import { ResponsiveMarimekko } from '@nivo/marimekko'

const sort = sampleData.sort(function(a, b) {
    return parseFloat(b.total) - parseFloat(a.total);
})

const data = sort
    data.forEach(datum => {
        datum.male *= 1
        datum.female *= -1
    })

const App = () => (
  <div className="App" style={{height: 500, fontFamily: 'sans-serif'}}>
    <ResponsiveMarimekko
        data={data}
        id="id"
        layout="horizontal"
        offset="diverging"
        value="total"
        dimensions={[
            {
                id: 'Female',
                value: 'female'
            },
            {
                id: 'Male',
                value: 'male'
            }
        ]}
        innerPadding={2}
        axisTop={null}
        axisRight={{
            orient: 'right',
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'Number of Male active physicians in the U.S. in 2019',
            legendOffset: 70,
            legendPosition: 'middle'
        }}
        axisBottom={{
            orient: 'bottom',
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: '',
            legendOffset: 36,
            legendPosition: 'middle',
            format: (v: number) => Math.abs(v),
        }}
        axisLeft={{
            orient: 'left',
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'Number of Female active physicians in the U.S. in 2019',
            legendOffset: -70,
            legendPosition: 'middle'
        }}
        margin={{ top: 40, right: 80, bottom: 100, left: 80 }}
        colors={[ '#F6B703' , '#3F708C']}
        valueFormat=" >-,"
        borderWidth={1}
        borderColor={{
            from: 'color',
            modifiers: [
                [
                    'darker',
                    0.2
                ]
            ]
        }}
        defs={[
            {
                id: 'lines',
                type: 'patternLines',
                background: 'rgba(0, 0, 0, 0)',
                color: 'inherit',
                rotation: -45,
                lineWidth: 4,
                spacing: 8
            }
        ]}
        fill={[
            {
                match: {
                    id: 'agree strongly'
                },
                id: 'lines'
            },
            {
                match: {
                    id: 'disagree strongly'
                },
                id: 'lines'
            }
        ]}
        legends={[
            {
                anchor: 'bottom',
                direction: 'row',
                justify: false,
                translateX: 0,
                translateY: 80,
                itemsSpacing: 0,
                itemWidth: 140,
                itemHeight: 18,
                itemTextColor: '#999',
                itemDirection: 'right-to-left',
                itemOpacity: 1,
                symbolSize: 18,
                symbolShape: 'square',
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemTextColor: '#000'
                        }
                    }
                ]
            }
        ]}
    />
  </div>
);

ReactDOM.render(<App />, document.getElementById("root"));